// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-bjqqManage-index-main_right_content-21w0t","table":"components-bjqqManage-index-table-txYZI"};


//////////////////
// WEBPACK FOOTER
// ./components/bjqqManage/index.css
// module id = 810
// module chunks = 0